// Keep the recovery sender contract in sync with billposter-expo/lib/auth/passwordRecoveryClient.ts.
import { createClient } from '@supabase/supabase-js';

/** Email recovery can be opened on another device (or outside the Expo app).
 * Do not bind it to the requesting client's private PKCE verifier or session.
 * Token-hash templates also work with this sender; template rollout is separate.
 */
export function createPasswordRecoveryClient(url: string, key: string) {
  return createClient(url, key, {
    auth: {
      flowType: 'implicit',
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
      storageKey: 'reactor-password-recovery-email',
    },
  });
}
